var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-btn c-btn--primary c-btn--w-large c-btn--h-xlarge c-btn--center",on:{"click":_vm.click}},[_vm._v("\n  カタログに応募する\n")])}
var staticRenderFns = []

export { render, staticRenderFns }